import { getCheckout, State as CheckoutState } from "./checkout";
import { CUSTOMER_TYPE, CustomerType } from "../../../../../constants";
import { PhoneNumbersState } from "../../../../../models/state";

export type State = CheckoutState;
export const getPhoneNumbers: (state: State) => Partial<PhoneNumbersState> = (state) =>
    getCheckout(state).phoneNumbers || {};
export const getSelectedPanel: (state: State) => CustomerType = (state) =>
    getPhoneNumbers(state).selectedPanel || CUSTOMER_TYPE.EXISTING;
export const getAvailablePhoneNumbers: (state: State) => string[] = (state) => getPhoneNumbers(state).available || [];
